<template>
  <div :class="['layout-wrapper', {'layout-collapse': collapse}]">
    <Sidebar />
    <div class="main-container">
      <Navbar />
      <AppMain />
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar'
import Navbar from './Navbar'
import AppMain from './AppMain'
import { mapGetters } from 'vuex'
export default {
  name: 'default',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['collapse']),
  },
  components: {
    Sidebar,
    Navbar,
    AppMain
  }
}
</script>

<style lang="scss" scoped>
.layout-wrapper{
  .sidebar{
    width: 240px;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #fff;
    box-sizing: border-box;
    overflow: hidden;
    transition: width .28s;
    border-right: 1px solid #e6e6e6;
    >>> .logo{
      padding: 15px 0 15px 7%;
      img{
        display: block;
        width: 160px;
      }
    }
    >>> .el-menu{
      background-color: #fff;
      border-right: 0;
      .el-menu-item,
      .el-submenu__title{
        color: $text2;
        transition: color .28s;
        .svg-icon{
          vertical-align: sub;
          margin-right: 5px;
        }
        &:hover{
          background-color: #D4EBF4 !important;
          &:not(.is-active){
            span,
            a,
            .svg-icon{
              color: $text1;
            }
          }
        }
      }
      .el-submenu{
        &.is-opened{
          .el-menu{
            background-color: #FFFFFF;
          }
        }
        &.is-active{
          .el-submenu__title{
            color: $theme-color;
            span{
              font-weight: bold;
            }
          }
        }
      }
      .el-menu-item{
        &.is-active{
          color: $theme-color;
        }
      }
    }
  }
  .main-container{
    min-height: 100vh;
    margin-left: 240px;
    position: relative;
    transition: margin-left .28s;
    .nav-bar{
      position: fixed;
      right: 0;
      top: 0;
      left: 240px;
      height: 50px;
      background-color: #FFFFFF;
      border-bottom: solid 1px #e6e6e6;
      z-index: 5;
      transition: left .28s;
      >>> .collapse-btn{
        transition: transform .28s;
        font-size: 20px;
        color: $text1;
      }
    }
    .app-main{
      min-height: 100vh;
      padding-top: 50px;
      box-sizing: border-box;
      overflow: hidden;
    }
  }
  &.layout-collapse{
    .sidebar{
      width: 36px;
      >>> .logo{
        img{
          width: 20px;
          height: 20px;
          margin-left: 5.5px;
        }
      }
      >>> .el-menu{
        width: 36px;
        .el-menu-item{
          width: 100%;
        }
        .el-menu-item,
        .el-menu-item .el-tooltip,
        .el-submenu__title{
          width: 100%;
          padding: 0 !important;
          .svg-icon{
            font-size: 16px;
            margin-left: 10px;
          }
          span,
          a{
            opacity: 0;
          }
        }
        .el-submenu{
          &.is-opened{
            .el-menu{
              background-color: unset;
            }
          }
        }
        .el-menu-item{
          &.is-active{
            background-color: unset;
          }
        }
      }
    }
    .main-container{
      margin-left: 36px;
      >>> .nav-bar{
        left: 36px;
        .collapse-btn{
          transform: rotate(90deg);
        }
      }
    }
  }
}
</style>
<style lang="scss">
.menu-popper{
  .el-menu{
    background-color: #fff;
    .el-menu-item{
      color: $text2;
      transition: color .28s;
      &:hover{
        color: $text1;
        background-color: #D4EBF4 !important;
      }
      &.is-active{
        color: $theme-color !important;
        background-color: #E9F5F9;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue